<template>
  <v-theme-provider dark>
    <base-section
      id="contact-us"
      class="primary"
      space="40"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="10">
            <base-title
              :space="$vuetify.breakpoint.mdAndUp ? 0 : 4"
              title="¿TIENE PREGUNTAS? ¡HAZNOS SABER!"
            />

            <base-body space="0">
              <span class="white--text">
                Envíanos un mensaje y te responderemos a la brevedad
              </span>
            </base-body>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <base-btn
              :block="$vuetify.breakpoint.smAndDown"
              color="white"
              href="mailto:contacto@cydgroup.com?subject=CydGroup Consulta"
              large
              outlined
              target="_blank"
            >
              Contactanos
            </base-btn>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionContactUs',
  }
</script>
